module.exports = __webpack_public_path__ + "3e39c62682c537dbcac99c88f401583d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/skateboard-red.png
// module id = 2444
// module chunks = 0